import script from "./DCStreaksTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./DCStreaksTable.vue?vue&type=script&lang=ts&setup=true"

import "./DCStreaksTable.vue?vue&type=style&index=0&id=2d785afb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d785afb"]])

export default __exports__
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTd,QPagination});
